<template>
  <div id="manage-tags-modal" uk-modal="esc-close: false; bg-close: false;">
    <div
      class="uk-modal-dialog uk-modal-body uk-margin-auto-vertical manage-tags-dialog"
    >
      <button class="uk-modal-close-default" type="button" uk-close></button>
      <h2>Manage Tags</h2>
      <p class="uk-text-muted">
        Tags are shared by org patterns and org photo patterns. Drag tags to set
        the order categories are shown in, reading left to right.
      </p>

      <draggable
        ref="list"
        v-model="orderedTags"
        :force-fallback="true"
        handle=".tag-handle"
        tag="ul"
        class="manage-tags-list"
        @change="saveOrder"
      >
        <li v-for="tag in orderedTags" :key="tag.id">
          <div class="uk-grid-small uk-flex-middle" uk-grid>
            <div class="uk-width-auto">
              <span class="tag-handle" uk-icon="table"></span>
            </div>
            <div class="uk-width-expand">
              <input
                :value="tag.name"
                class="uk-input uk-form-small"
                type="text"
                @change="renameTag(tag, $event)"
              />
            </div>
            <div class="uk-width-auto">
              <button
                v-if="pendingDeleteId !== tag.id"
                class="uk-button uk-button-default uk-button-small"
                type="button"
                @click="pendingDeleteId = tag.id"
              >
                Delete
              </button>
              <button
                v-else
                class="uk-button uk-button-danger uk-button-small"
                type="button"
                @click="deleteTag(tag)"
              >
                Really Delete?
              </button>
            </div>
          </div>
        </li>
      </draggable>
      <p v-if="!orderedTags.length" class="uk-text-muted">No tags yet.</p>

      <form
        class="uk-grid-small uk-margin-top"
        uk-grid
        @submit.prevent="createTag"
      >
        <div class="uk-width-expand">
          <input
            v-model="newTagName"
            class="uk-input"
            type="text"
            placeholder="New tag name"
          />
        </div>
        <div class="uk-width-auto">
          <button class="uk-button uk-button-primary" type="submit">
            Add Tag
          </button>
        </div>
      </form>
      <p v-if="error" class="uk-text-danger">{{ error }}</p>
    </div>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import DesignTagsService from "@/services/DesignTagsService";

export default {
  name: "ManageTagsModal",
  components: {
    draggable
  },
  props: {
    tags: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      orderedTags: [],
      newTagName: "",
      pendingDeleteId: null,
      error: ""
    };
  },
  watch: {
    tags: {
      immediate: true,
      handler(tags, previousTags) {
        this.orderedTags = [...tags];
        if (previousTags && tags.length > previousTags.length) {
          this.$nextTick(() => {
            const list = this.$refs.list.$el;
            list.scrollTop = list.scrollHeight;
          });
        }
      }
    }
  },
  methods: {
    nameTaken(name, exceptId) {
      return this.tags.some(
        tag =>
          tag.id !== exceptId && tag.name.toLowerCase() === name.toLowerCase()
      );
    },
    async save(write) {
      try {
        await write();
        this.error = "";
        this.$emit("changed");
      } catch (err) {
        this.error = "Could not save tags. Try again.";
      }
    },
    createTag() {
      const name = this.newTagName.trim();
      if (!name) {
        return;
      }
      if (this.nameTaken(name)) {
        this.error = `A tag named "${name}" already exists.`;
        return;
      }
      const nextOrder = Math.max(0, ...this.tags.map(tag => tag.order)) + 1;
      this.newTagName = "";
      return this.save(() => DesignTagsService.create(name, nextOrder));
    },
    renameTag(tag, event) {
      const name = event.target.value.trim();
      if (!name || name === tag.name) {
        event.target.value = tag.name;
        return;
      }
      if (this.nameTaken(name, tag.id)) {
        this.error = `A tag named "${name}" already exists.`;
        event.target.value = tag.name;
        return;
      }
      return this.save(() => DesignTagsService.rename(tag.id, name));
    },
    saveOrder() {
      return this.save(() => DesignTagsService.reorder(this.orderedTags));
    },
    deleteTag(tag) {
      this.pendingDeleteId = null;
      return this.save(() => DesignTagsService.remove(tag.id));
    }
  }
};
</script>

<style type="text/css">
.manage-tags-dialog {
  width: 800px;
}
.manage-tags-list {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0 20px;
  max-height: 50vh;
  margin: 0;
  padding: 0;
  overflow-y: auto;
  list-style: none;
}
.manage-tags-list > li {
  padding: 8px 0;
  border-bottom: 1px solid #e5e5e5;
}
@media (max-width: 640px) {
  .manage-tags-list {
    grid-template-columns: 1fr;
  }
}
.tag-handle {
  cursor: move;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/ManageTagsModal.vue